import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

// res = { status, data: [...], summary: {...} }
const getAll = async (params = {}) => {
  const res = await axios.get(`${API_URL}transactions`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
};

const create = async (body) => {
  const res = await axios.post(`${API_URL}transactions/create`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res.data;
};

// body: { id, status, note? }
const update = async (body) => {
  const res = await axios.post(`${API_URL}transactions/update`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res.data;
};

const remove = async (id) => {
  const res = await axios.post(
    `${API_URL}transactions/delete`,
    { id },
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res.data;
};

export default { getAll, create, update, remove };